import { render, staticRenderFns } from "./quotation-form-contact.vue?vue&type=template&id=e54402f8&scoped=true&"
import script from "./quotation-form-contact.vue?vue&type=script&lang=js&"
export * from "./quotation-form-contact.vue?vue&type=script&lang=js&"
import style0 from "./quotation-form-contact.vue?vue&type=style&index=0&id=e54402f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54402f8",
  null
  
)

export default component.exports